import { createLoggerFactory } from '@cvent/logging/LibraryLoggerFactory';
export const LoggerFactory = createLoggerFactory('@cvent/nextjs');
//# sourceMappingURL=LoggerFactory.js.map